import { Delete } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { humanize } from '../../lib/helper';
import {
  adminAddLogs,
  appSettingApi,
  fileUploadImage,
  updateSettingApi,
} from '../../Services/commonService';
import CustomButton from '../CommonComp/Buttons/CustomButton';
import { useDispatch } from 'react-redux';
import ApiConfig from '../../config/ApiConfig';
import {
  action,
  logsMessagesList,
  modulesNames,
} from '../../data/logsMessages';

function ImageUploadBackground({ item, parentKey }) {
  const [imageData, setImageData] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedImageData, setSelectedImageData] = useState(null);
  const imageInputRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (item?.key_value) {
      const timestampedUrl = `${item.key_value}?${Date.now()}`;
      setImageData(timestampedUrl);
    }
  }, [item?.key_value]);

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const ext = file.name.split('.').pop();
      const renamedFile = new File([file], `${item.key_name}.${ext}`, {
        type: file.type,
      });

      setImageData(URL.createObjectURL(file));
      setSelectedImageData(renamedFile);
    }
  };

  const getListing = async () => {
    dispatch(appSettingApi());
  };

  const handleSubmit = async () => {
    try {
      if (!selectedImageData) return;

      setLoading(true);

      const formData = new FormData();
      formData.append('uploaded_file', selectedImageData);
      formData.append('folder_name', 'backgrounds');

      const data = await fileUploadImage(formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (data?.status === 200) {
        const uploadedFileName = data.data;
        const imageUrl = `${ApiConfig?.S3_BASE_URL}backgrounds/${uploadedFileName}`;
        const timestampedUrl = `${imageUrl}?${Date.now()}`;

        setImageData(timestampedUrl);
        setSelectedImageData(null);

        const payload = {
          parent_key: parentKey,
          key_name: item.key_name,
          key_value: timestampedUrl,
        };

        const resp = await updateSettingApi(payload);

        if (resp) {
          await getListing();
          const logPayload = {
            action: action?.update,
            module: modulesNames?.cms,
            description: logsMessagesList?.cms?.backgroundImageUpdate,
          };
          await adminAddLogs(logPayload);
        }
      }
    } catch (error) {
      // Optional: add error handling UI/notifications here
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Typography variant="h5">{humanize(item?.key_name)}</Typography>
      <div className="borderBottom-1"></div>

      <Box sx={{ display: 'flex' }} className="my3">
        <div style={{ position: 'relative' }}>
          <Typography variant="h5" sx={{ mb: '2px', mt: '2px', ml: '10px' }}>
            Recommended Size : <strong>1920 X 1080</strong>
          </Typography>

          <CustomButton variant="contained" component="label" sx={{ p: 0 }}>
            <img
              id={`${item?.key_name}`}
              src={imageData}
              alt="Uploaded"
              style={{ maxWidth: 500 }}
              className="img-fluid rounded-2"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = '/default-image.png';
              }}
            />
            <input
              type="file"
              hidden
              ref={imageInputRef}
              onChange={onImageChange}
            />
          </CustomButton>

          {imageData?.includes('blob:') && (
            <div
              style={{
                position: 'absolute',
                top: 2,
                right: -35,
                zIndex: 10,
                padding: 2,
                color: 'red',
                cursor: 'pointer',
              }}
            >
              <Delete
                onClick={() => {
                  imageInputRef.current.value = null;
                  setImageData(`${item?.key_value}?${Date.now()}`);
                  setSelectedImageData(null);
                }}
              />
            </div>
          )}
        </div>
      </Box>

      <Box textAlign="right">
        <CustomButton
          type="button"
          onClick={handleSubmit}
          loading={loading}
          color="buttonPrimary"
          sx={{ px: '20px', py: '8px' }}
        >
          Save
        </CustomButton>
      </Box>
    </>
  );
}

export default ImageUploadBackground;
